<template>
    <employee-list
        :users="users"
        :count="count"
        :visibilityConfig="visibilityConfig"
        :page="params.page"
        v-on="$listeners"
        @updateTable="onUpdateTable"
        @refresh="onRefresh"
    />
</template>

<script>
import userListMixin from '@/mixins/UserList';

export default {
    name: 'employeeDeletedList',

    mixins: [userListMixin],

    data() {
        return {
            params: {
                includeDeleted: true
            },
            visibilityConfig: {
                actions: {
                    edit: false,
                    delete: false,
                    showHistory: true,
                    restore: true
                },
                search: true,
                refresh: true,
                excludeHeaders: null
            }
        };
    }
};
</script>
